import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { default as AkDropDownMenu } from '@atlaskit/dropdown-menu';
import AkMoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import AkTooltip from '@atlaskit/tooltip/Tooltip';

import type { CommonDropdownMenuProps } from './types';

const i18n = defineMessages({
	moreActions: {
		id: 'editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip',
		defaultMessage: 'More actions',
	},
});

export const CommonDropdownMenu = ({
	isMenuOpen,
	handleMenuOpenChange,
	children,
	testId = 'ellipsis-dropdown-menu',
	isDisabled,
	tooltipDisabledState,
}: CommonDropdownMenuProps) => {
	const { formatMessage } = useIntl();

	const disabledTooltipI18nObject = { id: tooltipDisabledState };
	const disabledTooltipText = tooltipDisabledState ? formatMessage(disabledTooltipI18nObject) : '';
	const tooltip = isDisabled ? disabledTooltipText : formatMessage(i18n.moreActions);

	return (
		<AkTooltip content={isMenuOpen ? '' : tooltip} position="bottom" hideTooltipOnClick>
			<div data-testid="ellipsis-dropdown-menu">
				<AkDropDownMenu
					placement="bottom-end"
					testId={testId}
					trigger={({ triggerRef, ...props }) => (
						<IconButton
							{...props}
							label={formatMessage(i18n.moreActions)}
							icon={AkMoreIcon}
							ref={triggerRef}
							isDisabled={isDisabled}
							appearance="subtle"
						/>
					)}
					appearance="tall"
					isOpen={isMenuOpen}
					onOpenChange={handleMenuOpenChange}
				>
					{children}
				</AkDropDownMenu>
			</div>
		</AkTooltip>
	);
};
